import React, {useEffect, useState} from "react";
import EventSummary from "../../types/EventSummary";
import PageHelper from "../../pages/PageHelper";
import "./RecentEvents.css"
import { EventService } from "../../services/EventService/EventService";

const RecentEvents: React.FC = () => {
  const [events, setEvents] = useState<EventSummary[]>([]);
  const [error, setError] = useState<string | null>(null);

  const RECENT_EVENT_COUNT = 10;

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const allEvents = await EventService.fetchEvents(0, true);
        // Get the 5 most recent events
        setEvents(allEvents.slice(0, RECENT_EVENT_COUNT));
      } catch (err) {
        setError(err instanceof Error ? err.message : "Unknown error");
      }
    };
    loadEvents();
  }, []);
  if (error) {
    return <div>Error: {error}</div>;
  }
  if (events.length === 0) {
    return <div>Loading events...</div>;
  }

  return (
    <div style={{ float:'left', width:'330px', height:'550px' }}>
      <div style={{float:'left'}}><h1>Recent Events</h1></div>
      <div style={{float:'right', marginTop:'10px', marginBottom:'10px'}}>
        <a className="link1" href="/events">view all Events</a>
      </div>
      <div style={{float:'left', overflow:'auto', width:'328px', height:'500px'}}>
        <table style={{border:'0'}} cellPadding="6" cellSpacing={0} width="100%">
          <tbody>
          {events.map((event, index) => (
            <tr key={event.id} className="recentList">
              <td>
                <a href={`/event/${event.id}`}>
                <img alt={event?.id} className="imageBorder"
                     src={event?.id && event?.eventThumb 
                        ? PageHelper.getImageSourceUrl(event.id, "thumb", event.eventThumb) 
                        : ""} />
                </a>
              </td>
              <td>
                {event.shortTitle}<br />
                {event.location}
                <br/>
                <span className="date">{event.date}</span>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentEvents;